import { OrdConnectProvider, Network as OrdNetwork } from "@ordzaar/ord-connect";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-wallets";
import React, { useMemo } from "react";
import { NotificationsProvider } from "../../context/NotificationsContext";
import {
  getSolanaEnvVars,
} from "../../utils/wallet_connect_utils";
import LogoutButton from "../Buttons/LogoutButton";
import LoginIcon from "../Icons/LoginIcon";
import ProfileIcon from "../Icons/ProfileIcon";
import SignUpIcon from "../Icons/SignUpIcon";
import Navbar from "../Navbar";
import MenuBrand from "./MenuBrand";
import MenuButton from "./MenuButton";

import "@solana/wallet-adapter-react-ui/styles.css";
import { AnonymousUserProvider } from "../../context/AnonymousUserContext";
import { WagmiConnectProvider } from "../../providers/WagmiEthereumProvider";

const verticalIconsSpace = global.props?.user
  ? "h-[calc(100%-180px)]"
  : "h-[calc(100%-265px)]";

function AppMenuDesktop(props) {
  return (
    <div className="menu-background fixed inset-y-0 left-0 hidden w-[100px] rounded-tr-lg rounded-br-lg border-r-[1px] border-brand-light-gray lg:block">
      <MenuBrand />
      <div
        className={`${verticalIconsSpace} mt-4 min-h-[110px] w-[100px] py-[16px]`}
      >
        <div className="flex h-full flex-col justify-start">
          <div className="rtl-scroll flex w-full flex-col space-y-[4vh] overflow-y-auto rounded-[20px]  text-center hover:overflow-y-auto">
            {global.props?.NAVBAR_OPTIONS.map((option) => (
              <MenuButton
                key={option.key}
                label={option.label}
                icon={
                  <img
                    src={option.icon}
                    alt={option.alt}
                    width={option.width}
                    height={option.height}
                  />
                }
                active={option.active}
                href={option.href}
                customClass={option.customClass}
                id={option.id}
                tooltip={option.tooltip}
                disabled={option.disabled}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="z-20 w-[100px] pb-4">
        {global.props?.user ? (
          <>
            <MenuButton
              label={global.user?.username}
              icon={<ProfileIcon currentAvatar={props.currentAvatar} />}
              active={props.profileStatus}
              href="/player/account-info"
              id="profile"
            />
            <LogoutButton className="flex cursor-pointer items-center justify-center text-[10px] text-red-500 underline decoration-1" />
          </>
        ) : (
          <>
            <MenuButton
              label="Log In"
              icon={<LoginIcon />}
              active={false}
              href={`/accounts/login/?next=${window.location.pathname}`}
              id="login"
              className="mb-[15px]"
            />
            <MenuButton
              label="Sign Up"
              icon={<SignUpIcon />}
              active={false}
              href="/accounts/signup"
              id="signup"
            />
          </>
        )}
      </div>
    </div>
  );
}

export default function AppLayout(props) {
  const currentAvatar = global.props?.user?.profile_avatar;
  const pageStatusProfile = [
    "accountInfo",
    "playerStatus",
    "hostStatus",
    "playerWallets",
  ].includes(global.props?.url_name);
  const solanaEnvVars = getSolanaEnvVars();
  const wallets = useMemo(
    () => [new PhantomWalletAdapter()],
    [solanaEnvVars.network]
  );
  return (
    <WagmiConnectProvider>
      <ConnectionProvider endpoint={solanaEnvVars.endpoint}>
        <OrdConnectProvider initialNetwork={OrdNetwork.MAINNET}>
          <WalletProvider wallets={wallets}>
            <WalletModalProvider>
              <AnonymousUserProvider>
                <NotificationsProvider>
                  <div
                    className={`flex  h-[100svh] flex-col items-center lg:ml-[100px] ${props.className ?? ""
                      }`}
                  >
                    <AppMenuDesktop
                      profileStatus={pageStatusProfile}
                      currentAvatar={currentAvatar}
                    />
                    <Navbar
                      headerLabel={
                        global.props.url_name
                          .replace(/([A-Z])/g, " $1")
                          .toUpperCase()
                          .trim() || "Play Now"
                      }
                      currentAvatar={global.props?.user?.profile_avatar}
                      currentUser={global.props?.user}
                    />
                    {props.children}
                  </div>
                </NotificationsProvider>
              </AnonymousUserProvider>
            </WalletModalProvider>
          </WalletProvider>
        </OrdConnectProvider>
      </ConnectionProvider>
    </WagmiConnectProvider>
  );
}
